/**
 * DEPRECATED — the v1 API this pointed at no longer exists.
 *
 * All API traffic now goes through `src/services/*` on top of
 * `src/config/axios.config.js` (https://api.ownfood.com/api/v2). This constant
 * survives only for unrouted legacy components under `Components/ChildComponents/`
 * and `Pages/`; do not wire new code to it.
 */
export const BaseURL = "";

/*=======================DashBoard Link ========================*/
export const DashBoardLink =
  process.env.REACT_APP_DASHBOARD_URL || "https://dashboard.ownfood.com";
export const FrontEndLink =
  process.env.REACT_APP_FRONTEND_URL || "https://ownfood.com";

// Mapping lives in src/services/mapbox.js — see MAPBOX_TOKEN there.
